import { render } from "./zxjj.vue?vue&type=template&id=f3d12be2&scoped=true"
import script from "./zxjj.vue?vue&type=script&lang=js"
export * from "./zxjj.vue?vue&type=script&lang=js"

import "./zxjj.vue?vue&type=style&index=0&id=f3d12be2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d12be2"]])

export default __exports__